export default getWebAnalyticsContainer;

function getWebAnalyticsContainer() {
  window.newDataLayer = window.newDataLayer || [];
  return window.newDataLayer;
}
